jQuery(document).ready(function($) {

    $( ".bloc_logos" ).each(function( index ) {

        var parent = $(this).find(".logos")
        var cibleLogos = parent.find(".logo")

        gsap.from( cibleLogos, {
            y : +200,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 50%",
                scrub: 1,
            }

        })


    })

});